module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_mobile-c987a52dd9d7c9d643706315f59f8411.jpg";